import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// --- Import hooks
import getQueryParams from "../../../hooks/getQueryParams";
// ---- Import components
import ErrorBoundary from "../../../components/ErrorBoundary/ErrorBoundary";
import PaymentMethodsList from "./PaymentMethodsList/PaymentMethodsList";
import ChangePaymentMethod from "./ChangePaymentMethod/ChangePaymentMethod";
// --- Import Images
import AddIcon from "../../../assets/images/add_icon.svg";
import HideIcon from "../../../assets/images/hide_icon.svg";
// --- Import styles
import "./PaymentMethods.sass";

function PaymentMethods() {
  const { search } = useLocation();
  const [displayChangeCard, setDisplayChangeCard] = useState(false);
  const [reloadList, setReloadList] = useState(false);
  const [expectedCard, setExpectedCard] = useState(null);
  const queryParams = getQueryParams(search);

  useEffect(() => {
    if (queryParams.payment !== undefined && queryParams.payment === "failed") {
      setDisplayChangeCard(true);
    }
  }, [search]);
  return (
    <div className="col-12">
      <article className="row flex-column align-items-start payment-methods">
        <section className="d-flex flex-column flex-sm-row  justify-content-between align-items-start align-items-sm-end section-title payment-methods__head">
          <h3 className="payment-methods__title">My payment methods</h3>
          <button
            className="add-btn"
            onClick={() => {
              setDisplayChangeCard(!displayChangeCard);
              setReloadList(false);
            }}
          >
            {displayChangeCard ? (
              <>
                <img src={HideIcon} alt="" className="add-btn__icon" />
                Cancel add payment
              </>
            ) : (
              <>
                <img src={AddIcon} alt="" className="add-btn__icon" />
                Add payment Method
              </>
            )}
          </button>
        </section>
        {displayChangeCard && (
          <ChangePaymentMethod
            onClose={() => {
              setDisplayChangeCard(false);
              setReloadList(true);
            }}
            setExpectedCard={setExpectedCard}
          />
        )}
        <ErrorBoundary
          classWrapper="payment-section__error"
          classText="payment-section__error-text"
        >
          <PaymentMethodsList
            shouldReload={reloadList}
            expectedCard={expectedCard}
            resetExpectedCard={() => setExpectedCard(null)}
          />
        </ErrorBoundary>
      </article>
    </div>
  );
}

export default PaymentMethods;
